import type { DirectiveBinding, ObjectDirective } from 'vue'

// 添加类名
function addClass(el: HTMLElement, cls: string) {
	if (!cls || !(cls = cls.trim())) return
	if (el.classList) {
		cls.split(/\s+/).forEach(c => c && el.classList.add(c))
	} else {
		const cur = ` ${el.getAttribute('class') || ''} `
		if (cur.indexOf(` ${cls} `) === -1) {
			el.setAttribute('class', (cur + cls).trim())
		}
	}
}

// 移除类名
function removeClass(el: HTMLElement, cls: string) {
	if (!cls || !(cls = cls.trim())) return
	if (el.classList) {
		cls.split(/\s+/).forEach(c => c && el.classList.remove(c))
	} else {
		const cur = ` ${el.getAttribute('class') || ''} `
		const tar = ` ${cls} `
		let val = cur.replace(tar, ' ')
		val = val.trim()
		if (val) {
			el.setAttribute('class', val)
		} else {
			el.removeAttribute('class')
		}
	}
}

// 设置隐藏
const setHide = (el: HTMLElement, binding: DirectiveBinding) => {
	if (typeof binding.value === 'string') {
		// 如果为空则删除
		if (binding.value === '' && el.className.indexOf('to-hide-tag-') > -1) {
			const tag = el.className[el.className.indexOf('to-hide-tag-') + 12]
			el.className = el.className.replace('to-hide-tag-' + tag, '')
		} else if (/^[a-z]$/.test(binding.value)) {
			// 如果已有 tag 则替换，如果没有则添加
			if (el.className.indexOf('to-hide-tag-') > -1) {
				const tag = el.className[el.className.indexOf('to-hide-tag-') + 12]
				el.className = el.className.replace('to-hide-tag-' + tag, 'to-hide-tag-' + binding.value)
			} else {
				addClass(el, 'to-hide-tag-' + binding.value + ' ')
			}
			// 鼠标悬移显示
			if (binding.arg === 'hover') {
				addClass(el, 'to-hide-type-hover')
			} else {
				removeClass(el, 'to-hide-type-hover')
			}
		}
	} else if (typeof binding.value === 'boolean') {
		if (binding.value) {
			addClass(el, 'to-hide')
		} else {
			removeClass(el, 'to-hide')
		}
	}
	if (binding.modifiers.keep) {
		addClass(el, 'to-hide-keep')
	}
	if (binding.modifiers.print) {
		addClass(el, 'to-hide-print')
	}
}

// 定义指令
export const vHide: ObjectDirective = {
	// Vue3的mounted对应Vue2的bind
	mounted(el: HTMLElement, binding: DirectiveBinding) {
		setHide(el, binding)
	},
	// Vue3的updated对应Vue2的update
	updated(el: HTMLElement, binding: DirectiveBinding) {
		setHide(el, binding)
	},
	// Vue3的unmounted对应Vue2的unbind
	unmounted(_el: HTMLElement) {
		// Vue3中不再需要手动销毁实例
	},
}
